var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0938 8.10165L10.8438 2.42197C10.6133 2.21115 10.3123 2.09424 10 2.09424C9.6877 2.09424 9.3867 2.21115 9.15626 2.42197L2.90626 8.10165C2.7783 8.21872 2.6761 8.36114 2.60616 8.51985C2.53622 8.67856 2.50007 8.85009 2.50001 9.02353V16.2188C2.49493 16.534 2.60619 16.8399 2.81251 17.0782C2.92961 17.2114 3.07387 17.3179 3.23557 17.3907C3.39728 17.4635 3.57269 17.5008 3.75001 17.5001H7.50001C7.66577 17.5001 7.82475 17.4342 7.94196 17.317C8.05917 17.1998 8.12501 17.0409 8.12501 16.8751V13.1251C8.12501 12.9593 8.19086 12.8004 8.30807 12.6831C8.42528 12.5659 8.58425 12.5001 8.75001 12.5001H11.25C11.4158 12.5001 11.5747 12.5659 11.692 12.6831C11.8092 12.8004 11.875 12.9593 11.875 13.1251V16.8751C11.875 17.0409 11.9409 17.1998 12.0581 17.317C12.1753 17.4342 12.3343 17.5001 12.5 17.5001H16.25C16.4573 17.5019 16.6617 17.4508 16.8438 17.3517C17.0419 17.2438 17.2073 17.0846 17.3228 16.8908C17.4383 16.697 17.4995 16.4757 17.5 16.2501V9.02353C17.5 8.85009 17.4638 8.67856 17.3939 8.51985C17.3239 8.36114 17.2217 8.21872 17.0938 8.10165Z",
    fill: "#00AC97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home_active.a1409bd5fd53ecd31dbdfe0bb8114185.svg";
export { ForwardRef as ReactComponent };